/*
PURPOSE: Editorial "small acts, real impact" section for the home page — the
collective-impact calculator, the real recent corals, and the start-your-coral CTA.
USE CASES:
- Fifth section of the home page, after Mission.
DOMAIN BOUNDARIES:
- Thin composition of editorial primitives + the EditorialImpactCalculator
  + the RecentCoralsBloom wrapper + verbatim
  useCopy().publicPages.home.coralDynamics / cta copy. Sections transition
  via the editorial hairline rule (no waves).
- The CTA scrolls to the hero creator via the passed callback.
*/

import React from 'react';
import { useCopy } from '../../../hooks/useCopy';
import { EditorialSection, Eyebrow, CtaPill } from '../../../components/editorial';
import EditorialImpactCalculator from './EditorialImpactCalculator';
import RecentCoralsBloom from '../../../components/RecentCoralsBloom/RecentCoralsBloom';

interface ImpactProps {
  onPersonalise: () => void;
}

const Impact: React.FC<ImpactProps> = ({ onPersonalise }) => {
  const copy = useCopy();

  return (
    <EditorialSection background="ivory" id="impact">
      <Eyebrow>{copy.publicPages.home.coralDynamics.sectionTitle}</Eyebrow>

      <div className="mt-8 max-w-2xl mx-auto">
        <EditorialImpactCalculator />
      </div>

      <div className="mt-16">
        <RecentCoralsBloom />
      </div>

      <div className="flex justify-center mt-16">
        <CtaPill onClick={onPersonalise}>{copy.publicPages.home.cta.personalise}</CtaPill>
      </div>
    </EditorialSection>
  );
};

export default Impact;
